import React from 'react';
import { Checkbox, Typography } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { Form } from 'antd';

interface CertificationByApplicantLegalDisclaimerProps {
  completed?: boolean;
  showAccountEstablishmentAttestation?: boolean;
}

export const CertificationByApplicantLegalDisclaimer: React.FC<CertificationByApplicantLegalDisclaimerProps> = (props) => {
  const cardStyle: React.CSSProperties = props.completed
    ? {
        cursor: 'not-allowed'
      }
    : {};

  return (
    <div
      className="border-4 border-black legal-textbox-scrollbar"
      style={{ ...cardStyle, border: '1px solid black', height: '400px', marginTop: '1%', padding: '2%', margin: '1% 10%', overflowX: 'hidden', overflowY: 'scroll' }}
    >
      {props.showAccountEstablishmentAttestation ? (
        <div>
          <div>
            <br />
            <Typography.Text strong>
              <p>Account Establishment Attestation</p>
            </Typography.Text>
          </div>

          <Paragraph>
            I hereby certify that the information that I have provided to establish a Credential Verification for Health Professionals (CVHP) Account was provided solely by me
            and is true and correct to the best of my knowledge. I understand that the decision as to whether I qualify for a CVHP Account or to receive any ECFMG services
            rests solely and exclusively with ECFMG and that ECFMG's decision-making authority is ongoing. I certify I understand that, among other things, ECFMG may report
            actual or suspected activities of irregular behavior to the entity to which I am applying; to U.S. and international medical registration and licensing
            authorities; educational institutions; places of employment; and/or any other organization or individual who, in the sole judgment of ECFMG has a legitimate
            interest in such information and/or where such disclosure is necessary for ECFMG to provide the requested services, and such reporting could result in actions to
            my professional practice, among other things. I understand that irregular behavior includes my submission of falsified documents and/or information to ECFMG as
            part of the services provided to me and/or other activities on my part that would or could subvert ECFMG’s processes and procedures.{' '}
          </Paragraph>
          <div>
            <Form.Item
              name={['isAttestationComplete', 'understandTerms']}
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
                }
              ]}
            >
              <Checkbox defaultChecked={props.completed} disabled={props.completed}>
                By checking this box, I certify that I have read, understood, and agree to the terms of the Credential Verification for Health Professionals (CVHP) Account
                Establishment Attestation as described above and agree to be legally bound by them.
              </Checkbox>
            </Form.Item>
            <br />
          </div>
        </div>
      ) : null}

      <div>
        <br />
        <Typography.Text strong>
          <p>Release of Legal Claims, Indemnification, and Hold Harmless Statement</p>
        </Typography.Text>
      </div>
      <div>
        <br />
        <Paragraph>
          I acknowledge that ECFMG makes no warranties, express or implied, as to any matter whatsoever, and any and all warranties are expressly disclaimed and excluded. I
          further acknowledge Intealth, its Board of Trustees, committees, officers, divisions ECFMG and FAIMER, employees, contractors, and agents (collectively, “Intealth”)
          shall not be liable for any losses, liabilities, or damages whatsoever, including, without limitation, any direct, indirect, consequential, incidental or special
          damages, arising from use of or reliance on ECFMG’s services.{' '}
        </Paragraph>

        <Paragraph>
          I hereby release Intealth of and from any and all liabilities, complaints, claims, lawsuits, damages, demands, losses, and expenses arising out of or in connection
          with any action or omission by Intealth in connection with any request and/or activities related to services that ECFMG provides to me; any investigation of my
          credentials, documents and actions; any investigation or finding of irregular behavior; and/or any failure or refusal to issue a report for CVHP services
          (collectively, “Claims”) whatsoever I may have, now and in the future, in consideration for the receipt of any services ECFMG provides to me. I also hereby agree to
          indemnify and hold harmless Intealth with respect to any and all Claims brought by myself or a third party (including Intealth’s reasonable attorneys’ fees incurred
          defending a Claim).{' '}
        </Paragraph>
      </div>

      <div>
        <Form.Item
          name={['isAttestationComplete', 'informationAuthorization']}
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
            }
          ]}
        >
          <Checkbox defaultChecked={props.completed} disabled={props.completed}>
            By checking this box, I certify that I have read, understood, and agree to the terms of the Release of Legal Claims, Indemnification, and Hold Harmless Statement
            as described above and agree to be legally bound by them.{' '}
          </Checkbox>
        </Form.Item>
        <br />
      </div>

      <div>
        <br />
        <Typography.Text strong>
          <p>Release of Information Authorization</p>
        </Typography.Text>
        <div>
          <Paragraph>
            I hereby request and authorize every person, medical regulatory authority, university, hospital, government agency, or other entity to release any documents and
            information to ECFMG bearing on the content of my application or other request related to services that I have asked ECFMG to provide to me, including, but not
            limited to: records, diplomas, transcripts, licenses/registrations, and other documents concerning my identity, citizenship or immigration status, educational,
            academic or professional history and status, or enrollment.{' '}
          </Paragraph>
          <Paragraph>
            I hereby authorize ECFMG to transmit any documents or information in its possession, or that may otherwise become available to ECFMG, bearing on the content of my
            application or other request related to services I have requested ECFMG provide to me, including, but not limited to: records; diplomas; transcripts;
            licenses/registrations; and other documents concerning my identity, citizenship or immigration status, educational, academic or professional history and status, or
            enrollment; and documentation of irregular behavior on my part to U.S. state and international medical licensing authorities; educational institutions, places of
            employment; and/or any other organization or individual who, in the sole judgment of ECFMG has a legitimate interest in such information and/or where such
            disclosure is necessary for ECFMG to provide the requested services. I understand that irregular behavior includes my submission of falsified documents and/or
            information to ECFMG as part of the services provided to me and/or other activities on my part that would or could subvert ECFMG’s processes and procedures.{' '}
          </Paragraph>
          <Paragraph>
            I also extend absolute immunity to, and release, other agencies, universities, institutions, hospitals and clinics, and registration and licensing authorities
            providing information, their employees, contractors, representatives, trustees, directors, and officers, and any third parties and organizations for their acts,
            communications, reports, records, diplomas, transcripts, statements, documents, recommendations, or disclosures involving me, made in good faith and without
            malice, requested by ECFMG.{' '}
          </Paragraph>
        </div>
        <Form.Item
          name={['isAttestationComplete', 'certificationAgreement']}
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
            }
          ]}
        >
          <Checkbox defaultChecked={props.completed} disabled={props.completed}>
            By checking this box, I certify that I have read, understood, and agree to the terms of the Release of Information Authorization as described above and agree to be
            legally bound by them.{' '}
          </Checkbox>
        </Form.Item>
      </div>

      <div>
        <br />
        <Typography.Text strong>
          <p>Acknowledgement of Terms and Conditions and Privacy Notice</p>
        </Typography.Text>
        <Form.Item
          name={['isAttestationComplete', 'termAcknowledgement']}
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
            }
          ]}
        >
          <Checkbox defaultChecked={props.completed} disabled={props.completed}>
            By checking this box, I confirm that I have read, understood, and agree to the{' '}
            <a href="https://www.intealth.org/terms/" target="_blank" rel="noopener noreferrer">
              Intealth Terms and Conditions
            </a>{' '}
            and{' '}
            <a href="https://www.intealth.org/privacy/" target="_blank" rel="noopener noreferrer">
              Intealth Privacy Notice
            </a>
            .
          </Checkbox>
        </Form.Item>
      </div>
    </div>
  );
};

